/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.galleryVideoList = Array.from(
        this.querySelectorAll('.gallery--video')
      );

      /*
       * Hover play videos
       */
      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      /*
       * Autoplay videos
       */
      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      /*
       * Autoplay
       */
      this.autoPlayList.forEach((item) => {
        const video = item.querySelector('video');

        if (!video) return;

        // Keep autoplay browser-safe
        video.muted = true;

        video.play().catch(() => {});
      });

      /*
       * Hover play
       */
      this.setHoverPlayList();

      /*
       * Sound controls
       */
      this.setSoundControls();

      /*
       * Animations
       */
      this.setAnimations();

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', () => {
          this.setAnimations();

          /*
           * Re-init sound controls in Theme Editor
           */
          this.setSoundControls();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }
    }

    /*
     * Hover play
     */
    setHoverPlayList() {
      this.hoverPlayList.forEach((item) => {
        const video = item.querySelector('video');

        if (!video) return;

        video.currentTime = 0.1;

        item.parentElement.addEventListener(
          'mouseenter',
          () => this.playVideo(item)
        );

        item.parentElement.addEventListener(
          'mouseleave',
          () => this.pauseVideo(item)
        );
      });
    }

    playVideo(videoContainer) {
      const video = videoContainer.querySelector('video');

      if (!video) return;

      video.play().catch(() => {});
    }

    pauseVideo(videoContainer) {
      const video = videoContainer.querySelector('video');

      if (!video) return;

      video.pause();
    }

    /*
     * Sound controls
     */
    setSoundControls() {
      const soundButtons = this.querySelectorAll(
        '[data-gallery-sound-toggle]'
      );

      soundButtons.forEach((button) => {

        /*
         * Prevent duplicate events
         */
        if (button.dataset.soundInitialized === 'true') {
          return;
        }

        button.dataset.soundInitialized = 'true';

        const videoContainer = button.closest(
          '.gallery--video-hosted'
        );

        if (!videoContainer) return;

        const video = videoContainer.querySelector('video');

        if (!video) return;

        const soundOn = button.querySelector(
          '.gallery-video__sound-on'
        );

        const soundOff = button.querySelector(
          '.gallery-video__sound-off'
        );

        /*
         * Initial state = muted
         */
        video.muted = true;

        this.updateSoundIcon(
          button,
          video,
          soundOn,
          soundOff
        );

        /*
         * Sound toggle
         */
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          video.muted = !video.muted;

          /*
           * If this is an autoplay video and somehow
           * stopped, keep it playing.
           *
           * Do NOT force hover-play videos to play.
           */
          if (
            video.paused &&
            !videoContainer.classList.contains('hover-play')
          ) {
            video.play().catch(() => {});
          }

          this.updateSoundIcon(
            button,
            video,
            soundOn,
            soundOff
          );
        });
      });
    }

    /*
     * Sound icon state
     */
    updateSoundIcon(
      button,
      video,
      soundOn,
      soundOff
    ) {
      if (video.muted) {

        /*
         * Muted icon
         */
        if (soundOn) {
          soundOn.style.setProperty(
            'display',
            'none',
            'important'
          );
        }

        if (soundOff) {
          soundOff.style.setProperty(
            'display',
            'flex',
            'important'
          );
        }

        button.classList.add('muted');

        button.setAttribute(
          'aria-label',
          'Turn sound on'
        );

      } else {

        /*
         * Sound on icon
         */
        if (soundOn) {
          soundOn.style.setProperty(
            'display',
            'flex',
            'important'
          );
        }

        if (soundOff) {
          soundOff.style.setProperty(
            'display',
            'none',
            'important'
          );
        }

        button.classList.remove('muted');

        button.setAttribute(
          'aria-label',
          'Mute video'
        );
      }
    }

    /*
     * Animations
     */
    setAnimations() {
      ScrollTrigger.batch(
        this.querySelectorAll('figure'),
        {
          start: 'top 90%',

          onEnter: (elements, triggers) => {
            gsap.to(elements, {
              opacity: 1,
              stagger: 0.15,
              ease: window.theme.settings.animation_easing
            });
          },
        }
      );
    }
  }

  customElements.define(
    'theme-gallery',
    ThemeGallery
  );
}